"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fp = require("../../utils/fp");

var _actions = require("./actions");

/**
 * Returns new state object updated to include new/updated entity values in
 * payload.
 *
 * @arg {object} state Entities state
 * @arg {object} updates Entities updates
 * @returns {object} New state object updated to include entities from payload
 *
 */
var updateEntities = function (state, updates) {
  var newState = (0, _extends2.default)({}, state);
  Object.keys(updates).forEach(function (entityType) {
    Object.keys(updates[entityType]).forEach(function (entityId) {
      newState[entityType] = (0, _extends2.default)({}, newState[entityType], {
        [entityId]: updates[entityType][entityId]
      });
    });
  });
  return newState;
};

var reducerFactory = function (_ref) {
  var initialState = _ref.initialState;
  return function (state, _ref2) {
    if (state === void 0) {
      state = initialState;
    }

    var type = _ref2.type,
        payload = _ref2.payload;

    if (type === _actions.ENTITIES_RECEIVE) {
      return updateEntities(state, payload);
    }

    if (type === _actions.ENTITIES_REMOVE) {
      var entityType = payload.entityType,
          entityIds = payload.entityIds;

      if (entityType in state && Array.isArray(entityIds)) {
        return entityIds.reduce(function (acc, entityId) {
          return (0, _fp.dissocPath)([entityType, entityId])(acc);
        }, state);
      }
    }

    return state;
  };
};

var _default = reducerFactory;
exports.default = _default;